<template>
	<div id="about" class="common_contents_wrap">
		<h2>ABOUT</h2>
		<p>
			ここは管理人ＡＲＡＩのホムペです！<br />
			一部ジャバスクリプト、ＰＮＧ画像を使用しています。<br />
			ご連絡は、ＣＯＮＴＡＣＴからどうぞ！質問、激励、苦情など・・・なんでもお気軽にメールください！<br />
			当ホムペはリンク自由です。が、連絡もらえると私が喜びます（笑）
		</p>
		<p class="about_practical_text">
			というテイストで作成したポートフォリオです。<br />
			最初は、自分のスキル不足を補うため＆自ら学び・アウトプットができる人間であることを転職でアピールするためにVue.js+Firebaseでサイトを作り始めたのですが、作っているうちに自分が小学生の頃に好きだったweb黎明期のホームページを再現したくなってしまい、キリ番BBSを作ったりリンク集を作ったりしているうちに20年ぶりにインターネットに触れた人が作った謎のサイトなのか、真剣に作ったポートフォリオなのか、大変わかりづらいものとなってしまいました。が、真剣に作ったポートフォリオです。絶賛転職先探し中です。気になった企業様はCONTACTからご連絡お願いします。
		</p>
	</div>
</template>

<script>
export default {
    data () {
        return {
            banner_image_src: require("../src/img/my_site_banner.png")
        }
    }
}
</script>